export const SET_USER_PROFILE = 'SET_USER_PROFILE';
export const CLEAR_USER_PROFILE = 'CLEAR_USER_PROFILE';

export default function reducer( state = {}, action ) {
  switch( action.type ) {
  case SET_USER_PROFILE: {
    state = {...state, user: {'profile': action.payload } };
    break;
  }
  case CLEAR_USER_PROFILE:{
    state = {...state, user: {'profile': action.payload } };
    break;
  }
  default:
    return state;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/redux/reducers/user.js